export const name = 'windowScroll' as const
export { VSM_EDITOR_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
export const WindowScrollApiSymbol = Symbol('windowScrollApi')
export const ResolvableReadyForScrollPromiseSymbol = Symbol('ResolvableWindowScrollPromise')
